export default [
  {
    id: 1,
    title: "How to get an SSL certificate for your Help Center's custom domain",
    status: 'draft',
    updatedAt: 1729205669,
    author: { availableName: 'Michael' },
    category: {
      slug: 'configuration',
      icon: '📦',
      name: 'Instalação e configuração',
    },
    views: 3400,
  },
  {
    id: 2,
    title: 'Como criar seu primeiro portal de ajuda',
    status: 'published',
    updatedAt: 1729205669,
    author: { availableName: 'John' },
    category: { slug: 'onboarding', icon: '🧑‍🍳', name: 'Primeiros passos' },
    views: 400,
  },
  {
    id: 3,
    title: 'Boas práticas para organizar o conteúdo do portal de ajuda',
    status: 'archived',
    updatedAt: 1729205669,
    author: { availableName: 'Fernando' },
    category: { slug: 'best-practices', icon: '⛺️', name: 'Boas práticas' },
    views: 400,
  },
  {
    id: 4,
    title: 'Como personalizar a aparência do portal de ajuda',
    status: 'draft',
    updatedAt: 1729205669,
    author: { availableName: 'Jane' },
    category: { slug: 'design', icon: '🎨', name: 'Design' },
    views: 400,
  },
  {
    id: 5,
    title: 'Como integrar o portal de ajuda a ferramentas de terceiros',
    status: 'published',
    updatedAt: 1729205669,
    author: { availableName: 'Sarah' },
    category: {
      slug: 'integrations',
      icon: '🔗',
      name: 'Integrações',
    },
    views: 2800,
  },
  {
    id: 6,
    title: 'Como gerenciar permissões de usuário no portal de ajuda',
    status: 'draft',
    updatedAt: 1729205669,
    author: { availableName: 'Alex' },
    category: {
      slug: 'administration',
      icon: '🔐',
      name: 'Administração',
    },
    views: 1200,
  },
  {
    id: 7,
    title: 'Como criar e manter seções de perguntas frequentes',
    status: 'published',
    updatedAt: 1729205669,
    author: { availableName: 'Emily' },
    category: {
      slug: 'content-management',
      icon: '📝',
      name: 'Gestão de conteúdo',
    },
    views: 5600,
  },
  {
    id: 8,
    title: 'Como implantar a busca no portal de ajuda',
    status: 'archived',
    updatedAt: 1729205669,
    author: { availableName: 'David' },
    category: {
      slug: 'features',
      icon: '🔍',
      name: 'Recursos',
    },
    views: 1800,
  },
  {
    id: 9,
    title: 'Como analisar as métricas de uso do portal de ajuda',
    status: 'published',
    updatedAt: 1729205669,
    author: { availableName: 'Rachel' },
    category: {
      slug: 'analytics',
      icon: '📊',
      name: 'Análises',
    },
    views: 3200,
  },
  {
    id: 10,
    title: 'Como oferecer o portal de ajuda em vários idiomas',
    status: 'draft',
    updatedAt: 1729205669,
    author: { availableName: 'Carlos' },
    category: {
      slug: 'localization',
      icon: '🌍',
      name: 'Localização',
    },
    views: 900,
  },
  {
    id: 11,
    title: 'Como criar tutoriais interativos dos seus produtos',
    status: 'published',
    updatedAt: 1729205669,
    author: { availableName: 'Olivia' },
    category: {
      slug: 'education',
      icon: '🎓',
      name: 'Educação',
    },
    views: 4100,
  },
  {
    id: 12,
    title: 'Como implantar um sistema de avaliação no portal de ajuda',
    status: 'draft',
    updatedAt: 1729205669,
    author: { availableName: 'Nathan' },
    category: {
      slug: 'user-engagement',
      icon: '💬',
      name: 'Engajamento',
    },
    views: 750,
  },
  {
    id: 13,
    title: 'Como otimizar o conteúdo do portal de ajuda para SEO',
    status: 'published',
    updatedAt: 1729205669,
    author: { availableName: 'Sophia' },
    category: {
      slug: 'seo',
      icon: '🚀',
      name: 'SEO',
    },
    views: 2900,
  },
  {
    id: 14,
    title: 'Como criar uma base de conhecimento para equipes internas',
    status: 'archived',
    updatedAt: 1729205669,
    author: { availableName: 'Daniel' },
    category: {
      slug: 'internal-resources',
      icon: '🏢',
      name: 'Recursos internos',
    },
    views: 1500,
  },
];
